const {store, AoflElement} = aofljs;
/**
 * @summary CdivFooterLinks
 * @class CdivFooterLinks
 * @extends {AoflElement}
 */
class CdivFooterLinks extends AoflElement {
  /**
   * Creates an instance of CdivFooterLinks.
   * @memberof CdivFooterLinks
   */
  constructor() {
    super(store);
  }

  /**
   *
   * @readonly
   * @static
   * @memberof CdivFooterLinks
   */
  static get is() {
    return 'cdiv-footer-links';
  }
}

window.customElements.define(CdivFooterLinks.is, CdivFooterLinks);



// WEBPACK FOOTER //
// ./cdiv/en-US/js/cdiv-footer-links/cdiv-footer-links.js